//note: position is in steps by percentage of height and width
// literals can be used for more precision
export const SLIDE_LAYOUT = {
  TITLE: {
    X_POSITION: 1,
    Y_POSITION: 1.4,
    WIDTH: '80%' as const,
    HEIGHT: '40%' as const,
    FONT_SIZE: 48,
    ALIGN: 'center' as const,
  },
  CONTENT: {
    TITLE: {
      X_POSITION: 1,
      Y_POSITION: 0.5,
      Y_POSITION_LONG: 0.3,
      WIDTH: '80%' as const,
      FONT_SIZE_NORMAL: 28,
      FONT_SIZE_LONG: 26,
      TITLE_LENGTH_THRESHOLD: 30,
    },
    SEPARATOR: {
      X_POSITION: '10%' as const,
      Y_POSITION: 1.3,
      Y_POSITION_LONG: 1.5,
      WIDTH: '80%' as const,
      HEIGHT: 0,
      LINE_WIDTH: 1,
    },
    TEXT: {
      X_POSITION: 1,
      Y_POSITION: 1.3,
      Y_POSITION_LONG: 1.5,
      WIDTH: '80%' as const,
      FONT_SIZE: 24,
      ALIGN: 'justify' as const,
      VALIGN: 'top' as const,
    },
    BULLET: {
      CODE: '2022' as const, // Unicode bullet point character
    },
    LEADING_TEXT: {
      X_POSITION: 1,
      Y_POSITION: 1.7, // slightly above bullets/points
      WIDTH: '80%' as const,
      FONT_SIZE: 22,
      FONT_STYLE: 'italic' as const,
      COLOR: '#444444',
      MARGIN_BOTTOM: 0.3, // extra space below leading text
    },
  },
  CENTERED_FOCUS: {
    X_POSITION: 1,
    Y_POSITION: 1.6,
    WIDTH: '80%' as const,
    HEIGHT: '40%' as const,
    FONT_SIZE: 28,
  },
  GRID: {
    FONT_SIZE: 20,
    TITLE_FONT_SIZE: 24,
    QUADRANT: {
      TOP_Y_POSITION: 1.8,
      BOTTOM_Y_POSITION: 3.1,
      LEFT_X_POSITION: 0.5,
      RIGHT_X_POSITION: 5.3,
      WIDTH: 4.5,
      HEIGHT: 1.0,
      CONTAINER: {
        X_POSITION: 0.3,
        Y_POSITION: 1.6,
        WIDTH: 9.4,
        HEIGHT: 2.7,
      },
      TEXT_MARGIN: [0, 0, 0, 0.2] as [number, number, number, number], // top, right, bottom, left
    },
    COMPARISON: {
      Y_POSITION: 1.6,
      TITLE_Y_POSITION: 1.2,
      LEFT_X_POSITION: 0.5,
      RIGHT_X_POSITION: 5.0,
      WIDTH: 4.5,
      HEIGHT: 2.0,
    },
  },
  LEFT_CONTENT: {
    FONT_SIZE: 22,
    X_POSITION: 1,
    Y_POSITION: 1.8,
    WIDTH: 5.0,
    HEIGHT: 3.5,
  },
  RIGHT_CONTENT: {
    FONT_SIZE: 22,
    X_POSITION: 4.0,
    Y_POSITION: 1.8,
    WIDTH: 5.0,
    HEIGHT: 3.5,
  },
};

// PDF specific constants
export const PDF_LAYOUT = {
  PAGE: {
    ORIENTATION: 'landscape' as const,
    UNIT: 'in' as const,
    WIDTH: 10,
    HEIGHT: 5.63,
  },
  TITLE: {
    X_POSITION: 5,
    FONT_SIZE: 48,
    MAX_WIDTH: 8,
    TITLE_LENGTH_THRESHOLD: 20,
  },
  CONTENT: {
    TITLE: {
      X_POSITION: 1,
      Y_POSITION: 0.5,
      Y_POSITION_LONG: 0.3,
      FONT_SIZE_NORMAL: 36,
      FONT_SIZE_LONG: 30,
      MAX_WIDTH: 8.3,
      TITLE_LENGTH_THRESHOLD: 26,
    },
    SEPARATOR: {
      START_X: 0.5,
      END_X: 9.5,
      Y_POSITION: 1.1,
      Y_POSITION_LONG: 1.3,
      LINE_WIDTH: 0.01,
    },
    TEXT: {
      X_POSITION: 1,
      Y_POSITION: 1.8,
      Y_POSITION_LONG: 1.9,
      FONT_SIZE: 22,
      MAX_WIDTH: 8.3,
      Y_ADDITION: 0.5,
    },
    LEADING_TEXT: {
      X_POSITION: 1,
      Y_POSITION: 1.7,
      FONT_SIZE: 20,
      FONT_STYLE: 'italic' as const,
      COLOR: '#444444',
      MAX_WIDTH: 8.3,
      MARGIN_BOTTOM: 0.3,
    },
  },
  CENTERED_FOCUS: {
    X_POSITION: 5,
    Y_POSITION: 1.8,
    FONT_SIZE: 32,
    MAX_WIDTH: 8,
  },
  GRID: {
    FONT_SIZE: 18,
    TITLE_FONT_SIZE: 22,
    QUADRANT: {
      TOP_Y_POSITION: 1.8,
      BOTTOM_Y_POSITION: 3.1,
      LEFT_X_POSITION: 1.0,
      RIGHT_X_POSITION: 5.5,
      WIDTH: 4.0,
      HEIGHT: 1.0,
      CONTAINER: {
        X_POSITION: 0.8,
        Y_POSITION: 1.6,
        WIDTH: 8.7,
        HEIGHT: 2.7,
      },
    },
    COMPARISON: {
      TITLE_Y_POSITION: 1.4,
      CONTENT_Y_POSITION: 2.0,
      CENTER_X_LEFT: 2.0,
      CENTER_X_RIGHT: 6.5,
      DIVIDER_X: 5.0,
      MAX_TEXT_WIDTH: 3.5,
      BULLET_INDENT: 0.3,
      LEFT_X_POSITION: 1.0,
    },
  },
  LEFT_CONTENT: {
    FONT_SIZE: 20,
    X_POSITION: 2.75,
    Y_POSITION: 1.8,
    BULLET_X_POSITION: 2.45,
    TEXT_WIDTH: 4.0,
    TEXT_INDENT: 2.75,
  },
  RIGHT_CONTENT: {
    FONT_SIZE: 20,
    X_POSITION: 7.25,
    Y_POSITION: 1.8,
    BULLET_X_POSITION: 6.95,
    TEXT_WIDTH: 4.0,
    TEXT_INDENT: 7.25,
  },
};
